import { PRO_BONO_V2 } from "../../constants/featureFlags";

export const LEGACY_PRO_BONO_PATH = "/pro-bono";
export const PRO_BONO_REFERRALS_PATH = "/pro-bono-referrals";

/**
 * Where the Pro Bono Leads / Pro Bono Referrals list (and, under it, a request's detail page) lives. GROWTH-7941: the flag decides, so
 * every navigate, link and "am I on the detail page" check moves together instead of each keeping its own copy of the path.
 *
 * @returns {string}
 */
export const getProBonoBasePath = () => (PRO_BONO_V2 ? PRO_BONO_REFERRALS_PATH : LEGACY_PRO_BONO_PATH);
